module.exports = __webpack_public_path__ + "static/img/HTFJJ.9d40cf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HTFJJ.png
// module id = XjGE
// module chunks = 34